module.exports = __webpack_public_path__ + "img/hindi.034c7d9a.png";